import theme from "@/styles/novaTheme";
import styled from "@emotion/styled";

export const HomeContainer = styled.div`
  padding-bottom: 0.6em;
  min-height: 84dvh;

  > div:first-of-type {
    background-color: ${theme.colors.green100};
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.5em 0;

    > span {
      color: ${theme.colors.blueGray1000};
      font-style: italic;
      font-size: 0.9em;
      margin: 0.9em 0;
      text-align: left;
    }

    > svg {
      margin: 0 4px;
      min-width: 1em;
    }
  }

  > div:nth-of-type(2n) {
    display: grid;
    justify-items: center;
    justify-content: center;
    grid-template-columns: auto auto;
    gap: 1rem;

    @media (max-width: 1030px) {
      grid-template-columns: 1fr;
      padding-bottom: 2em;
      gap: 0;
    }

    > div {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 1em;
      max-width: 520px;
      min-width: 350px;

      section {
        margin-bottom: 1em;
      }
    }

    > div:first-of-type {
      > iframe {
        max-width: 100%;
        aspect-ratio: 16 / 9;
        border: none;
        border-radius: 1em;
        margin: 0.6em 0;
      }

      > p {
        margin: 0.6em 0;
      }
    }
  }
`;
